export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas por cobrar"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen de facturas por cobrar a los proveedores"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver detalles"])},
          "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moneda"])},
          "total_num_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas por cobrar"])},
          "percent_receivable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Porcentaje por cobrar"])},
          "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total por cobrar"])}
        }
      }
    }
  })
}